// extracted by mini-css-extract-plugin
export default {"wrapper":"StatusIcon_wrapper__rjFnR","success":"StatusIcon_success__hnFGG","failed":"StatusIcon_failed__TEX3V"};